import React from "react";
import MicIcon from "@mui/icons-material/Mic";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import gurujiAvatar from "../../assets/guruji-portrait.png";
import "./VoiceBot.scss";

interface VoiceBotTriggerButtonProps {
  onClick: () => void;
  className?: string;
}

export const VoiceBotTriggerButton: React.FC<VoiceBotTriggerButtonProps> = ({
  onClick,
  className = "",
}) => {
  return (
    <div
      className={`voiceBotFloatingTrigger ${className}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      title="Consult Shree Valmiki Guruji - Live Vedic Voice Consultation"
    >
      <div className="triggerAvatarContainer">
        <img
          src={gurujiAvatar}
          alt="Shree Valmiki Guruji"
          className="triggerAvatarImg"
        />
        <span className="triggerLivePulse" />
      </div>

      <div className="triggerTextContainer">
        <div className="triggerBadge">
          <AutoAwesomeIcon className="sparkleIcon" sx={{ fontSize: 11 }} />
          <span>LIVE CONSULTATION</span>
        </div>
        <div className="triggerTitleRow">
          <span className="triggerTitle">Shree Valmiki Guruji</span>
          <div className="triggerMicBadge">
            <MicIcon className="triggerMicIcon" sx={{ fontSize: 13 }} />
          </div>
        </div>
        <div className="triggerSubtitle">Vedic Voice Guidance</div>
      </div>
    </div>
  );
};
